import React, { useState } from "react";
import { LandingComponent } from "../landing";
import { PasswordEntryComponent } from "../password_entry";
import { PasswordCreationComponent } from "../password_creation";
import { ForgotPasswordComponent } from "../forgot_password";
import { checkIfUserExists } from "../../../services/authentication/email-checker";

type AuthView =
  | "landing"
  | "passwordEntry"
  | "passwordCreation"
  | "forgotPassword";

interface AuthenticationContainerProps {
  onAuthenticationSuccess: () => void;
}

export const AuthenticationContainer = ({
  onAuthenticationSuccess,
}: AuthenticationContainerProps) => {
  const [currentView, setCurrentView] = useState<AuthView>("landing");
  const [userEmail, setUserEmail] = useState("");

  const switchToLanding = () => setCurrentView("landing");
  const switchToPasswordEntry = () => setCurrentView("passwordEntry");
  const switchToPasswordCreation = () => setCurrentView("passwordCreation");
  const switchToForgotPassword = () => setCurrentView("forgotPassword");

  const handleEmailSubmit = async (email: string) => {
    setUserEmail(email);

    try {
      const result = await checkIfUserExists(email);
      console.log("Email check result for", email, ":", result);

      if (result.error) {
        // If there's an error, show it in the landing component
        // For now, we'll default to password creation to avoid blocking users
        console.warn("Email check error:", result.error);
        console.log("Routing to password creation due to error");
        switchToPasswordCreation();
      } else if (result.exists) {
        // User exists, go to password entry
        console.log("User exists, routing to password entry");
        switchToPasswordEntry();
      } else {
        // User doesn't exist, go to password creation
        console.log("User does not exist, routing to password creation");
        switchToPasswordCreation();
      }
    } catch (error) {
      console.error("Failed to check email:", error);
      // Default to password creation to avoid blocking users
      console.log("Exception occurred, defaulting to password creation");
      switchToPasswordCreation();
    }
  };

  const handleGoogleSignIn = () => {
    // Google sign-in is handled by the redirect, so we just need to wait
    // The authentication context will handle the success
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case "landing":
        return (
          <LandingComponent
            onEmailSubmit={handleEmailSubmit}
            onGoogleSignIn={handleGoogleSignIn}
          />
        );
      case "passwordEntry":
        return (
          <PasswordEntryComponent
            email={userEmail}
            onSwitchToForgotPassword={switchToForgotPassword}
            onSwitchToLanding={switchToLanding}
            onSignInSuccess={onAuthenticationSuccess}
          />
        );
      case "passwordCreation":
        return (
          <PasswordCreationComponent
            email={userEmail}
            onSwitchToLanding={switchToLanding}
            onSwitchToPasswordEntry={switchToPasswordEntry}
            onSignUpSuccess={onAuthenticationSuccess}
          />
        );
      case "forgotPassword":
        return <ForgotPasswordComponent onSwitchToSignIn={switchToLanding} />;
      default:
        return (
          <LandingComponent
            onEmailSubmit={handleEmailSubmit}
            onGoogleSignIn={handleGoogleSignIn}
          />
        );
    }
  };

  return <>{renderCurrentView()}</>;
};
